export default {
  router: [
    {
      exact: true,
      path: '/CarrierManagement/dailyRowLine',
      title: '每日排线结果&司机指派',
    },
  ],
  title: '每日排线结果&司机指派',
};
